import { HomeSceneBrand } from './home-scene-brand';
import { HOME_SCENES } from '../constants/home-copy';
import { HomeSceneSeeding } from './home-scene-seeding';
import { HomeSceneContents } from './home-scene-contents';
import { HomeSceneCreators } from './home-scene-creators';
import { HomeSceneTracking } from './home-scene-tracking';

import type { HomeSceneId } from '../constants/home-copy';

// ----------------------------------------------------------------------

/** 장면 id → 그리는 부품 */
const SCENE_VIEWS: Record<HomeSceneId, typeof HomeSceneContents> = {
  contents: HomeSceneContents,
  brand: HomeSceneBrand,
  creators: HomeSceneCreators,
  tracking: HomeSceneTracking,
  seeding: HomeSceneSeeding,
};

/** 장면 다섯 — 차례는 `HOME_SCENES` 가 정한다 */
export function HomeScenes() {
  return (
    <>
      {HOME_SCENES.map((scene) => {
        const Scene = SCENE_VIEWS[scene.id];
        return <Scene key={scene.id} scene={scene} />;
      })}
    </>
  );
}
